export default __webpack_public_path__ + "static/media/inner_tl1.ad3bf047.png";